import React, { useEffect, useState } from 'react';
import { Virtual, Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { getCustomer, imgBaseUrl } from '../../utils/api';
import './customerList.css';
import Slider from "react-slick";

export default function BlogsSlider() {
  const [customers, setCustomers] = useState([]);

  // Fetch customer data
  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const pay = { pageSize: 0, pageIndex: 0 };
        const res = await getCustomer(pay);
        setCustomers(res.data.data.items);
      } catch (error) {
        console.error('Error fetching customers:', error);
      }
    };
    fetchCustomer();
  }, []);
  const settings = {
    rtl: true,
    infinite: customers.length > 5, // فقط وقتی محصولات بیشتر از 4 تا باشند، اسلایدر حلقه‌ای می‌شود
    arrows: true,
    draggable: true, // فقط وقتی محصولات بیشتر از 4 باشد، اسلایدر قابل جابجایی است
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 5, // تعداد اسلایدها محدود به تعداد محصولات
          slidesToScroll: 1,
          autoplay: true, // فقط وقتی محصولات بیشتر از 4 تا باشند، اسلاید خودکار فعال می‌شود

        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: true, // فقط وقتی محصولات بیشتر از 4 تا باشند، اسلاید خودکار فعال می‌شود

        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true, // فقط وقتی محصولات بیشتر از 4 تا باشند، اسلاید خودکار فعال می‌شود

        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow:4,
          slidesToScroll: 1,
          autoplay: true, // اضافه کردن autoplay در اینجا
          autoplaySpeed: 3000,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true, // اضافه کردن autoplay در اینجا
          autoplaySpeed: 3000,
          arrows: true,
        },
      },
    ],
  };
  return (

    <>
      <Slider {...settings} adaptiveHeight={true}>
        {customers.map((item, index) => (
          <div className="">
            <div className="img-box customer-list">
              <img src={imgBaseUrl + '80x80/' + item.logoPath} alt={item.name} />
            </div>
          </div>
        ))
        }
      </Slider>

    </>

  );
}
